import { TPatient } from 'src/types/patient'
import { useTranslation } from 'react-i18next'
import { getFormattedDate } from 'src/utils/date-formatter.util'
import { CurecallButton, ECurecallButtonAppearance } from '@honestica/curecall-ui'
import { useModals } from 'src/providers/modals.provider'

const PatientConsent = ({ patient }: { patient: TPatient }) => {
  const { t } = useTranslation()
  const { openConsentModal } = useModals()

  return (
    <>
      {patient?.PatientConsent?.consentStatus === false && (
        <p className="c-m-0 c-italic c-text-grey-600 c-font-nexa">
          {t('components.patient.patient-file.header.consent.refused-consent', {
            date: getFormattedDate(patient.PatientConsent.consentDate),
          })}
        </p>
      )}

      {patient?.Project?.consentNeeded && (
        <>
          {patient?.PatientConsent?.consentStatus === null && (
            <p className="c-m-0 c-font-italic c-text-muted">
              {t('components.patient.patient-file.header.consent.consent-not-yet-obtained', {
                date: getFormattedDate(patient.PatientConsent.consentSendDate),
              })}
            </p>
          )}
          {patient?.PatientConsent?.consentStatus === true && (
            <p className="c-m-0 c-font-italic c-text-muted">
              {t('components.patient.patient-file.header.consent.consent-validated', {
                date: getFormattedDate(patient.PatientConsent.consentDate),
              })}
            </p>
          )}

          {!patient?.PatientConsent?.consentStatus && (
            <CurecallButton
              onClick={() => openConsentModal({ patientId: patient.id })}
              appearance={ECurecallButtonAppearance.ALERT}
            >
              {t('components.patient.patient-file.header.consent.obtain-consent')}
            </CurecallButton>
          )}
        </>
      )}
    </>
  )
}

export default PatientConsent
